/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { ActionType } from "@bms/common";
import React from "react";
import { useTranslation } from "react-i18next";

import { Dialog, MediaButton } from "components";
import { useModal } from "context/modal";
import { RouteHelper } from "helpers";

import "./LogOutModal.scss";

export const LogOutModal = () => {
  const { t } = useTranslation();
  const { dismissModal } = useModal();

  const logoutAction = async () => {
    await RouteHelper.performAction({
      ActionType: ActionType.SignInOut,
    });
    dismissModal();
  };
  return (
    <Dialog
      wrapClassName="LogOutModal"
      destroyOnClose
      footer={null}
      visible
      onCancel={dismissModal}
    >
      <span className="LogOutModal__Header">{t("LOGOUT__QUESTION")}</span>
      <div className="LogOutModal__Actions">
        <MediaButton type="button" variant="primary" onClick={logoutAction}>
          {t("COMMON__YES")}
        </MediaButton>
        <MediaButton type="button" variant="secondary" onClick={dismissModal}>
          {t("COMMON__NO")}
        </MediaButton>
      </div>
    </Dialog>
  );
};
